<template>

<div class="container-fluid">
    <div class="row">
        <div class="col">

            <h2 class="m-3">
                <span>Project Status</span>
                <button class="btn btn-sm btn-primary ms-4" @click="loadList()">
                    <i class="fa fa-refresh"></i>
                    Refresh
                </button>
                <router-link to="/logout" class="btn btn-secondary btn-sm ms-2">
                    <i class="fas fa-right-from-bracket"></i>
                    Logout
                </router-link>
            </h2>

            <table class="table table-sm">

                <tbody v-if="!projects.length">
                    <tr>
                        <td colspan="2">
                            No Project Status Found ...
                        </td>
                    </tr>
                </tbody>

                <!-- 
                <thead>
                    <tr>
                    <th class="p-2">Priority</th>
                    <th class="p-2">ID</th>
                    <th class="p-2"><nobr>Project Name</nobr></th>
                    <th class="p-2"><nobr>Complete By Date</nobr></th>
                    <th class="p-2">Progress</th>
                    <th class="p-2">Status</th>
                    <th class="p-2"><nobr>Service Report</nobr></th>
                    </tr>
                </thead>
                -->

                <tbody v-for="row in projects">
                    <tr v-if="printStatus(row)">
                        <td colspan="2" class="grey-bg p-2 border-bottom-dark">
                            <h5 class="text-start">{{ row.Status_In_Database }}</h5>
                        </td>
                    </tr>
                    <!-- show the headers again ... -->
                    <tr v-if="printStatus(row)">
                        <th class="p-2 dark-bg text-light">Priority</th>
                        <th class="p-2 dark-bg text-light">Details</th>

                        <!-- 
                        <th class="p-2 dark-bg text-light">ID</th>
                        <th class="p-2 dark-bg text-light"><nobr>Project Name</nobr></th>
                        <th class="p-2 dark-bg text-light"><nobr>Complete By Date</nobr></th>
                        <th class="p-2 dark-bg text-light">Progress</th>
                        <th class="p-2 dark-bg text-light">Status</th>
                        <th class="p-2 dark-bg text-light"><nobr>Service Report</nobr></th>
                        -->
                    </tr>

                    <tr>
                        <td class="p-2">{{ row.Priority || 0 }}</td>
                        <td>
                            <table class="table-sm">
                                <tbody>
                                <tr>
                                    <td class="px-2">Id</td>
                                    <td class="px-2">{{ row.Project_ID }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2">Edit</td>
                                    <td class="px-2">
                                        <button 
                                            @click="editRecord(row)"
                                            class="btn btn-sm btn-secondary"
                                        >Edit</button></td>
                                </tr>
                                <tr>
                                    <td class="px-2">Name</td>
                                    <td class="px-2">{{ row.RequestDescription }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2">Progress</td>
                                    <td class="px-2">
                                        <div 
                                            class="progress p-0" 
                                            role="progressbar" 
                                            aria-label="Progress bar" 
                                            :aria-valuenow="row.Progress" 
                                            aria-valuemin="0" 
                                            aria-valuemax="100"
                                            style="width: 200px"
                                        >
                                            <div 
                                                class="progress-bar" 
                                                :style="getWidth(row.Progress)"
                                            >{{ row.Progress }}%</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2">Status</td>
                                    <td class="px-2">{{ row.Status_To_Customer }}</td>
                                </tr>
                                <tr>
                                    <td class="px-2">Finished</td>
                                    <td class="px-2">
                                        {{ row.CompletionDate }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="px-2">Report</td>
                                    <td class="px-2">
                                        <span v-if="row.ServiceReport">
                                        <a
                                            v-if="isUrl(row.ServiceReport)" 
                                            :href="row.ServiceReport" 
                                            target="_blank"
                                        ><i class="fa fa-link"></i> View Report</a>
                                        <span v-else>
                                            {{ row.ServiceReport }}
                                        </span>
                                    </span>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                        </td>
                        <!-- 
                        <td class="p-2">{{ row.Project_ID }}</td>
                        <td class="p-2"><nobr>{{ row.RequestDescription }}</nobr></td>
                        <td class="p-2">{{ row.CompletionDate }}</td>
                        <td class="p-2">

                            <div 
                                class="progress" 
                                role="progressbar" 
                                aria-label="Progress bar" 
                                :aria-valuenow="row.Progress" 
                                aria-valuemin="0" 
                                aria-valuemax="100"
                                style="width: 200px"
                            >
                                <div 
                                    class="progress-bar" 
                                    :style="getWidth(row.Progress)"
                                >{{ row.Progress }}%</div>
                            </div>

                        </td>
                        <td class="p-2"><nobr>{{ row.Status_To_Customer }}</nobr></td>
                        <td class="p-2">
                            <span v-if="row.ServiceReport">
                                <a
                                    v-if="isUrl(row.ServiceReport)" 
                                    :href="row.ServiceReport" 
                                    target="_blank"
                                ><i class="fa fa-link"></i> View Report</a>
                                <span v-else>
                                    <nobr>{{ row.ServiceReport }}</nobr>
                                </span>
                            </span>
                        </td>
                        -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>

<kt-modal
    :visible="showModal"
    :title="'Edit Project'"
    @dismiss="showModal = false;"
>

<template #body>

    <div class="row">
        <div class="col">
            <label for="Progress" class="form-control">
                <span class="d-block">
                    Progress %
                </span>
                <kt-input
                    type="text"
                    v-model="form.Progress"
                ></kt-input>
            </label>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col">
            <label for="Progress" class="form-control">
                <span class="d-block">
                    Status
                </span>
                <kt-input
                    type="textarea"
                    v-model="form.TextStatus"
                    rows="6"
                ></kt-input>
            </label>
        </div>
    </div>

</template>

<template #footer>
    <div class="row">
        <div class="col-6">
            <button class="btn btn-secondary -btn-sm form-control" @click="showModal = false;">
                <small>Cancel</small>
            </button>
        </div>
        <div class="col-6">
            <button class="btn btn-primary -btn-sm form-control" @click="updateForm()">
                <small>Update</small>
            </button>
        </div>
    </div>
</template>
    

</kt-modal>

</template>

<script lang="ts" setup>

import { ref, onMounted } from "vue";
import Api from "@/services/Api";
import ApiService from "@/services/ApiService";
import Helper from "@/services/Helper";
import { RequestModel } from "@/models/RequestModel";
import KtInput from "@/components/UI/KtInput.vue";
import KtModal from "@/components/UI/KtModal.vue";


const projects = ref([]);
let allStatus = {};
const num = ref(0);

const showModal = ref(false);

const form = ref<RequestModel | null>(null);

const editRecord = async (row:any) =>
{
    let rec = await ApiService.loadRequest(row.Project_ID);
    form.value = rec;
    showModal.value = true;

};

const updateForm = async () =>
{
    let rec = Helper.prep(form.value);
    console.debug("rec", rec);
    rec = await ApiService.saveRequest(rec);
    form.value = null;
    showModal.value = false;
    
}

const loadList = async () =>
{
    allStatus = {};
    let rs = await Api.getProjectStatus();
    projects.value = rs;
};

const isUrl = (val) =>
{
    return (-1 < val.indexOf("://"));
};

const getWidth = (val) =>
{
    return "width: " + (val || 0) + "%";
};

const printStatus = (row) =>
{
    if (allStatus[row.Status_In_Database] == 2)
    {
        return false;
    }

    allStatus[row.Status_In_Database] = 
        (allStatus[row.Status_In_Database] || 0) + 1;

    return true;
};

onMounted(async () => {

    loadList();

});

</script>

<style scoped>

</style>